module.exports = __webpack_public_path__ + "img/BCA.34c74d2d.png";